import { types, getParent, applySnapshot, flow } from 'mobx-state-tree';
import { LocationDetail } from './models';

const LocationStore = types
  .model('LocationStore', {
    location: types.optional(LocationDetail, {}),
  })
  .volatile(self => ({
    loading: false,
    submitting: false,
  }))
  .views(self => ({
    get root() {
      return getParent(self);
    },
  }))
  .actions(self => ({
    setLocation(location) {
      applySnapshot(self.location, location);
    },
    loadLocation: flow(function* (id) {
      try {
        self.loading = true;
        self.setLocation({});
        const response = yield self.root.api.location.show(id);
        self.setLocation(response.data.data);
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.loading = false;
    }),
    submit: flow(function* (e, locationId) {
      e && e.preventDefault && e.preventDefault();

      let response;
      try {
        self.submitting = true;
        if (locationId != 0) {
          response = yield self.root.api.location.update(self.location.id, self.location);
        }
        else {
          response = yield self.root.api.location.store(self.location);
        }
        self.setLocation(self.location);
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.submitting = false;

      return response;
    }),
  }))


export default LocationStore;
